import UpdateRatePlan from './Edit';

export default UpdateRatePlan;
